window.pageInitFlag = false

pageInit = ->


$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/open_data.coffee